import { render, staticRenderFns } from "./CarCharges.vue?vue&type=template&id=49ce715d&scoped=true&"
import script from "./CarCharges.vue?vue&type=script&lang=js&"
export * from "./CarCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ce715d",
  null
  
)

export default component.exports